<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item v-if="!drawer" :label="$t('views.specOption.form.specIdLabel')" prop="specId" >
        <a-input v-model="form.specId" :placeholder="$t('views.specOption.form.specIdPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.spec.form.name')" prop="name" >
        <a-input v-model="form.name" :disabled="simpleMode" :placeholder="$t('views.spec.form.namePlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.spec.form.nameEn')" prop="nameEn" >
        <a-input v-model="form.nameEn" :disabled="simpleMode" :placeholder="$t('views.spec.form.nameEnPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item v-if="!simpleMode && !drawer" :label="$t('views.specOption.form.parentId')" prop="parentId" >
        <a-input v-model="form.parentId" :placeholder="$t('views.specOption.form.parentIdPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item v-if="!simpleMode && !drawer" :label="$t('views.specOption.form.isCalculationInput')" prop="isCalculation" >
        <a-input v-model="form.isCalculation" :placeholder="$t('views.specOption.form.isCalculationInputPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item v-if="!simpleMode && !drawer" :label="$t('views.specOption.form.type')" prop="type" >
      </a-form-model-item>
      <a-form-model-item v-if="!simpleMode && !drawer" :label="$t('views.specOption.form.isRequiredInput')" prop="isRequired" >
        <a-input v-model="form.isRequired" :placeholder="$t('views.specOption.form.isRequiredInputPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item v-if="!simpleMode" :label="$t('views.spec.form.isConflict')" prop="isConflict" >
        <a-select v-model="form.isConflict" :placeholder="$t('views.spec.form.isConflictPlaceholder')" allow-clear>
          <a-select-option :value="0">{{ $t('views.specOption.format.no') }}</a-select-option>
          <a-select-option :value="1">{{ $t('views.specOption.format.yes') }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item v-if="!simpleMode" :label="$t('views.spec.form.optionRemark')" prop="remark" >
        <a-input v-model="form.remark" :placeholder="$t('views.spec.form.optionRemarkPlaceholder')" type="textarea" :auto-size="{ minRows: 2, maxRows: 6 }" />
      </a-form-model-item>
      <a-form-model-item v-if="!simpleMode" :label="$t('views.spec.form.optionRemarkEn')" prop="remarkEn" >
        <a-input v-model="form.remarkEn" :placeholder="$t('views.spec.form.optionRemarkEnPlaceholder')" type="textarea" :auto-size="{ minRows: 2, maxRows: 6 }" />
      </a-form-model-item>

      <a-form-model-item v-if="!simpleMode" :label="$t('views.spec.form.isPrompt')" prop="isPrompt" >
        <a-select v-model="form.isPrompt" :placeholder="$t('views.spec.form.isPromptPlaceholder')" allow-clear>
          <a-select-option :value="0">{{ $t('views.specOption.format.promptOff') }}</a-select-option>
          <a-select-option :value="1">{{ $t('views.specOption.format.promptOn') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="!simpleMode && !drawer" :label="$t('views.spec.form.defaultOption')" prop="defaultOption" >
        <a-input v-model="form.defaultOption" :placeholder="$t('views.specOption.form.defaultOptionValuePlaceholder')" />
      </a-form-model-item>

      <a-form-model-item v-if="showCalc && !simpleMode" :label="$t('views.spec.form.sellingPrice')" prop="sellingPrice" >
        <a-input-number v-model="form.sellingPrice" style="width: 100%;" :min="0" :step="0.001" />
      </a-form-model-item>
      <a-form-model-item v-if="showCalc || simpleMode" :label="simpleMode ? $t('views.spec.form.valueLabel') : $t('views.spec.form.costPrice')" prop="costPrice" >
        <a-input-number v-model="form.costPrice" style="width: 100%;" :min="0" :step="0.001" />
      </a-form-model-item>
      <a-form-model-item v-if="showManuscriptFee && !simpleMode" :label="$t('views.spec.form.manuscriptFee')" prop="manuscriptFee" >
        <a-input-number v-model="form.manuscriptFee" style="width: 100%;" :min="0" :step="0.01" />
      </a-form-model-item>

      <a-form-model-item v-if="showDensity && !simpleMode" :label="$t('views.spec.form.materialDensity')" prop="materialDensity" >
        <a-input-number v-model="form.materialDensity" style="width: 100%;" :min="0" :step="0.01" />
      </a-form-model-item>
      <a-form-model-item v-if="showDensity && !simpleMode" :label="$t('views.spec.form.membraneWidth')" prop="membraneWidth" >
        <a-input-number v-model="form.membraneWidth" style="width: 100%;" :min="0" :step="0.01" />
      </a-form-model-item>
      <a-form-model-item v-if="showDensity && !simpleMode" :label="$t('views.spec.form.isThickness')" prop="isThickness" >
        <a-select v-model="form.isThickness" :placeholder="$t('views.spec.form.selectPlaceholder')" allow-clear>
          <a-select-option :value="0">{{ $t('views.specOption.format.no') }}</a-select-option>
          <a-select-option :value="1">{{ $t('views.specOption.format.yes') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="showDensity && !simpleMode && Number(form.isThickness) === 1" :label="$t('views.spec.form.materialThickness')" prop="materialThickness" >
        <a-input-number v-model="form.materialThickness" style="width: 100%;" :min="0" :step="0.01" />
      </a-form-model-item>

      <!-- 与规格 CreateForm 一致：指定所属规格 id 时维护重量、单位 -->
      <a-form-model-item v-if="showOptionWeightUnit" :label="$t('views.spec.form.optionWeight')" prop="weight" >
        <a-input-number v-model="form.weight" style="width: 100%;" :min="0" :step="0.01" />
      </a-form-model-item>
      <a-form-model-item v-if="showOptionWeightUnit" :label="$t('views.spec.form.optionUnit')" prop="unitOfMeasurement" >
        <a-input v-model="form.unitOfMeasurement" :placeholder="$t('views.spec.form.optionUnitPlaceholder')" allow-clear />
      </a-form-model-item>
      <!-- 所属规格 id=647456342948352000（拉链）或 653169480406573056（封口条） -->
      <a-form-model-item v-if="showOptionLaborCosts" :label="optionLaborCostsLabel" prop="laborCosts" >
        <a-input-number v-model="form.laborCosts" style="width: 100%;" :min="0" :step="0.001" />
      </a-form-model-item>
      <a-form-model-item v-if="showOptionLaborWeight" :label="$t('views.spec.form.optionLaborWeight')" prop="laborWeight" >
        <a-input-number v-model="form.laborWeight" style="width: 100%;" :min="0" :step="0.01" />
      </a-form-model-item>

      <a-form-model-item v-if="!simpleMode && Number(form.isPrompt) === 1" :label="$t('views.spec.form.imagePrompt')" prop="url" >
        <a-input v-model="form.url" :placeholder="$t('views.spec.form.imageUrlPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item v-if="!simpleMode && Number(form.isPrompt) === 1" :label="$t('views.spec.form.contentPrompt')" prop="content" >
        <a-input v-model="form.content" :placeholder="$t('views.spec.form.contentPromptPlaceholder')" type="textarea" :auto-size="{ minRows: 3, maxRows: 12 }" allow-clear />
      </a-form-model-item>
      <a-form-model-item v-if="!simpleMode && Number(form.isPrompt) === 1" :label="$t('views.spec.form.contentEnPrompt')" prop="contentEn" >
        <a-input v-model="form.contentEn" :placeholder="$t('views.spec.form.contentEnPromptPlaceholder')" type="textarea" :auto-size="{ minRows: 3, maxRows: 12 }" allow-clear />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.spec.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.spec.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSpecOption, addSpecOption, updateSpecOption } from '@/api/user/specOption'

export default {
  name: 'CreateForm',
  props: {
    simpleMode: {
      type: Boolean,
      default: false
    },
    drawer: {
      type: Boolean,
      default: false
    },
    fixedSpecId: {
      type: [String, Number],
      default: null
    },
    showCalc: {
      type: Boolean,
      default: false
    },
    showDensity: {
      type: Boolean,
      default: false
    },
    /** 印刷效果规格：图稿费用 */
    showManuscriptFee: {
      type: Boolean,
      default: false
    },
    /** 所属规格「是否参与计算」0/1，新增/保存时写入子表与主规格一致 */
    specIsCalculation: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        specId: null,

        name: null,

        nameEn: null,

        parentId: null,

        isCalculation: null,

        type: null,

        isRequired: null,

        isConflict: null,

        isCustomization: null,

        identityRestrictions: null,

        isPrompt: null,

        defaultOption: null,

        sellingPrice: null,

        costPrice: null,

        manuscriptFee: null,

        materialDensity: null,

        membraneWidth: null,

        isThickness: null,

        materialThickness: null,

        url: null,

        content: null,

        contentEn: null,

        sort: null,

        status: 1,

        createTime: null,

        remark: null,

        remarkEn: null,

        laborCosts: null,

        laborWeight: null,

        weight: null,

        unitOfMeasurement: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules () {
      return {
        name: [
          { required: true, message: this.$t('views.spec.rule.nameRequired'), trigger: 'blur' }
        ]
      }
    },
    /** 当前选项所属规格 ID（编辑来自接口 / 新增来自 fixedSpecId 或表单） */
    effectiveSpecId () {
      if (this.form && this.form.specId !== null && this.form.specId !== undefined && this.form.specId !== '') {
        return String(this.form.specId)
      }
      if (this.fixedSpecId !== null && this.fixedSpecId !== undefined && this.fixedSpecId !== '') {
        return String(this.fixedSpecId)
      }
      return ''
    },
    /** 指定所属规格 id 时：子选项重量、单位 */
    showOptionWeightUnit () {
      if (this.simpleMode) return false
      const id = this.effectiveSpecId
      if (!id) return false
      const set = new Set([
        '653168147729391617',
        '653168447877980160',
        '653169211895619585',
        '653169480406573056',
        '647456342948352000',
        '668054146120830976'
      ])
      return set.has(id)
    },
    /** 所属规格 id=647456342948352000（拉链）或 653169480406573056（封口条） */
    showOptionLaborCosts () {
      if (this.simpleMode) return false
      const id = this.effectiveSpecId
      return id === '647456342948352000' || id === '653169480406573056'
    },
    /** 仅拉链规格展示 laborWeight */
    showOptionLaborWeight () {
      if (this.simpleMode) return false
      return this.effectiveSpecId === '647456342948352000'
    },
    optionLaborCostsLabel () {
      if (this.effectiveSpecId === '653169480406573056') {
        return this.$t('views.spec.form.optionLaborCostsSealStrip')
      }
      return this.$t('views.spec.form.optionLaborCosts')
    }
  },
  watch: {
    specIsCalculation (val) {
      if (!this.open) return
      this.applySpecIsCalculation(val)
    }
  },
  mounted () {
  },
  methods: {
    /** 子选项 isCalculation 与所属主规格一致 */
    applySpecIsCalculation (val) {
      const v = val === null || val === undefined || val === '' ? 0 : Number(val)
      const n = Number.isNaN(v) ? 0 : (v === 1 ? 1 : 0)
      this.$set(this.form, 'isCalculation', n)
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        specId: null,
        name: null,
        nameEn: null,
        parentId: null,
        isCalculation: null,
        type: null,
        isRequired: null,
        isConflict: 0,
        isCustomization: null,
        identityRestrictions: null,
        isPrompt: 0,
        defaultOption: null,
        sellingPrice: null,
        costPrice: null,
        manuscriptFee: null,
        materialDensity: null,
        membraneWidth: null,
        isThickness: 1,
        materialThickness: null,
        url: null,
        content: null,
        contentEn: null,
        sort: 0,
        status: 1,
        createTime: null,
        remark: null,
        remarkEn: null,
        laborCosts: null,
        laborWeight: null,
        weight: null,
        unitOfMeasurement: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      if (this.drawer && this.fixedSpecId !== undefined && this.fixedSpecId !== null && this.fixedSpecId !== '') {
        this.form.specId = this.fixedSpecId
        this.form.parentId = 0
      }
      if (!this.drawer) {
        // 新增默认一级选项
        this.form.parentId = this.form.parentId !== null && this.form.parentId !== undefined ? this.form.parentId : 0
      }
      this.applySpecIsCalculation(this.specIsCalculation)
      this.open = true
      this.formTitle = this.$t('views.spec.title.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSpecOption({"id":id}).then(response => {
        const d = response.data || {}
        this.form = {
          ...d,
          remarkEn: d.remarkEn != null && d.remarkEn !== '' ? d.remarkEn : d.remark_en,
          weight: d.weight,
          laborCosts: d.laborCosts != null ? d.laborCosts : d.labor_costs,
          laborWeight: d.laborWeight != null ? d.laborWeight : d.labor_weight,
          unitOfMeasurement: d.unitOfMeasurement != null && d.unitOfMeasurement !== '' ? d.unitOfMeasurement : d.unit_of_measurement,
          manuscriptFee: d.manuscriptFee != null ? d.manuscriptFee : d.manuscript_fee
        }
        if (this.form.content == null) {
          this.form.content = ''
        }
        if (this.form.contentEn == null) {
          this.form.contentEn = ''
        }
        if (this.showDensity && (this.form.isThickness === null || this.form.isThickness === undefined || this.form.isThickness === '')) {
          this.form.isThickness = 1
        }
        this.applySpecIsCalculation(this.specIsCalculation)
        this.open = true
        this.formTitle = this.$t('views.spec.title.edit')
      })
    },
    /** 提交前去掉当前规格不需要的字段，避免把未展示列误更新为 null */
    buildSubmitPayload () {
      const payload = { ...this.form }
      if (!this.showOptionWeightUnit) {
        delete payload.weight
        delete payload.unitOfMeasurement
      }
      if (!this.showOptionLaborCosts) {
        delete payload.laborCosts
      }
      if (!this.showOptionLaborWeight) {
        delete payload.laborWeight
      }
      if (!this.showManuscriptFee) {
        delete payload.manuscriptFee
      }
      return payload
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.applySpecIsCalculation(this.specIsCalculation)
          const payload = this.buildSubmitPayload()
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSpecOption(payload).then(response => {

              if(response.success) {
                this.$message.success(this.$t('views.spec.msg.updateOk'),3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.spec.msg.updateFail');
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSpecOption(payload).then(response => {
              if(response.success) {
                this.$message.success(this.$t('views.spec.msg.addOk'),3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.spec.msg.addFail');
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
